export const FETCH_BASE_URL = process.env.REACT_APP_FETCH_BASE_URL;
export const ERP_FETCH_BASE_URL = process.env.REACT_APP_ERP_FETCH_BASE_URL;
export const ERP_URL = process.env.REACT_APP_ERP_URL;
export const IS_DEVELOPMENT =
  process.env.NODE_ENV === "development" ? true : false;
